/**
 * Shared Supabase Client
 * Single instance to avoid multiple GoTrueClient warnings
 */

import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config/env';

const anonAuthStorageKey = 'roadserve-anon-auth';

// Create single Supabase client instance
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storageKey: anonAuthStorageKey,
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});

